import { Box, Grid, Button, Link } from "@mui/material";
import { ReactComponent as FayeIcon } from "../../icons/FayeLight.svg";
import GridPage from "components/layout/GridPage";
import useIsMobile from "components/hooks/useIsMobile";
import VideoCall from "pages/VideoCall";
import { styled } from "@mui/material/styles";

const VideoContainer = styled(Box)({
  backgroundColor: "#FFF",
  height: "calc(100vh - 72px)",
  overflow: "hidden",
  "& > div:first-of-type": {
    height: "100% !important",
    "& > div": {
      height: "100% !important",
    },
  },
});

export default () => {
  const isMobile = useIsMobile();

  return (
    <GridPage sx={{ padding: "0px" }}>
      <Grid
        container
        sx={{
          height: "72px",
          backgroundColor: "#FDFAF7",
          borderBottom: "1px solid #E8E8E8",
        }}
      >
        <Grid
          item
          xs={isMobile ? 6 : 8}
          sx={{ paddingLeft: isMobile ? "35px" : "70px" }}
        >
          <Box
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                color: "#FFFFFF",
                width: "100%",
                maxWidth: "750px",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                "& svg path": {
                  fill: "#198282",
                },
              }}
            >
              <Link
                href="https://findfaye.com"
                target="_blank"
                underline="none"
              >
                <FayeIcon />
              </Link>
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          xs={isMobile ? 6 : 4}
          sx={{ paddingRight: isMobile ? "14px" : "20px" }}
        >
          <Box
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Button variant={"outlined"} aria-label="Learn more">
              <Link
                href="https://findfaye.com"
                target="_blank"
                underline="none"
              >
                Learn more
              </Link>
            </Button>
            <Button variant={"contained"} aria-label="Login">
              <Link
                href={`/member-login?destination=${encodeURIComponent(
                  window.location.pathname + window.location.search,
                )}`}
                underline="none"
                sx={{ color: "inherit" }}
              >
                Login
              </Link>
            </Button>
          </Box>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <VideoContainer>
            <VideoCall />
          </VideoContainer>
        </Grid>
      </Grid>
    </GridPage>
  );
};
